import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import {ViajeDTO} from "../../../dtos/viaje.dto";
import {BsModalRef} from "ngx-bootstrap/modal";
import {ViajeService} from "../../services/viaje.service";
import {ApiService} from "../../services/api.service";
import moment from "moment/moment";
import {GetDetalleViajeResponseDTO} from "../../../dtos/response/getDetalleViaje.response.dto";
import {GeneralResponseDTO} from "../../../dtos/response/general.response.dto";
import {AppMessage} from "../../app.message";
import {PostFinalizarViajeResquestDTO} from "../../../dtos/request/postFinalizarViaje.resquest.dto";
import {DetalleViajeDTO} from "../../../dtos/detalleViaje.dto";
import {FormsModule} from "@angular/forms";
import {EventService} from "../../services/event.service";
import {HttpErrorResponse} from "@angular/common/http";
import {NgClass, NgIf} from "@angular/common";
import { PdfDTO } from '../../../dtos/pdf.dto';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-modal-terminar-viaje',
  standalone: true,
  imports: [
    FormsModule,
    NgIf,
    NgClass
  ],
  templateUrl: './modal-terminar-viaje.component.html',
  styleUrl: './modal-terminar-viaje.component.scss'
})
export class ModalTerminarViajeComponent {

  public viaje: ViajeDTO;
  public detalleViaje: DetalleViajeDTO;
  public porcentajeCombustible: number = 50;
  public estadoBus: string = 'DISPONIBLE';
  public estadoConductor: string = 'DISPONIBLE';
  public busInhabilitado: boolean = false;
  public puedeFinalizarJornada : boolean = false;
  public enviando: boolean = false;

  constructor(private modalRef: BsModalRef, private viajeService: ViajeService, private apiService: ApiService,
              private eventService: EventService, private toastr: ToastrService, private userService: UserService) {
    this.viaje = this.viajeService.getViajeSeleccionado();
    this.getDetalleViaje();
    this.validaSiPuedeFinalizarJornada();
    this.eventService.subscribe('VIAJE_ACTUALIZADO_MQTT_EVENT', (viaje: DetalleViajeDTO) => {
      if(viaje.uuid == this.viaje.uuid) {
        this.viaje = viaje;
        this.detalleViaje = viaje;
      }
    })
  }

  validaSiPuedeFinalizarJornada() {
    const fechaTerminoPlanificado = this.viaje?.conductor?.jornadaEnCurso?.fechaTerminoPlanificado;
  
    if (fechaTerminoPlanificado) {
      const ahora = moment();
      const termino = moment(fechaTerminoPlanificado);
      const diffMinutos = termino.diff(ahora, "minutes");
  
      this.puedeFinalizarJornada = diffMinutos <= 30;
    }
  
    console.log("fechaTerminoPlanificado:", fechaTerminoPlanificado);
    console.log("ahora:", moment().toISOString());
    console.log("puedeFinalizarJornada:", this.puedeFinalizarJornada);
    
  }

  close() {
    this.modalRef.hide()
  }

  tienePermisoFinalizarViaje(): boolean {
    return this.userService.tienePermiso('VIAJE_FINALIZAR');
  }

  muestraHora(fecha: string) {
    if(!fecha)
      return '';

    return moment.utc(fecha).local().format('HH:mm');
  }

  muestraDiferenciaHorasMinutos(fechaTermino: string, fechaLlegada: string) {
    if(!fechaTermino)
      return'';

    if(fechaLlegada)
      return this.muestraDiferenciaViajeTerminado(fechaTermino, fechaLlegada);

    const fecha2 = moment.utc(fechaTermino);
    const fecha1 = moment().utc();
    let diferencia = 0;
    if(fecha2 >= fecha1) {
      diferencia = fecha2.diff(fecha1);
      return moment.duration(diferencia).format('HH:mm');
    }else {
      diferencia = fecha1.diff(fecha2);
      return '+' + moment.duration(diferencia).format('HH:mm');
    }
  }

  muestraDiferenciaViajeTerminado(fechaTermino: string, fechaLlegada: string) {
    const fecha2 = moment.utc(fechaTermino);
    const fecha1 = moment.utc(fechaLlegada);
    let diferencia = 0;
    if(fecha2 >= fecha1) {
      diferencia = fecha2.diff(fecha1);
      return moment.duration(diferencia).format('HH:mm');
    }else {
      diferencia = fecha1.diff(fecha2);
      return '+' + moment.duration(diferencia).format('HH:mm');
    }
  }

  mostraHorasDisponibles() {
    if(!this.detalleViaje || !this.detalleViaje.conductor || !this.detalleViaje.conductor.jornadaEnCurso || this.detalleViaje.conductor.jornadaEnCurso.minutosRestantes == 0)
      return '00:00';

    return moment.duration(this.detalleViaje.conductor.jornadaEnCurso.minutosRestantes * 60 * 1000).format("HH:mm");
  }

  convertirMinutosEnHoras(minutos: number) {
    if(!minutos)
      return '00:00';

    return moment.duration(minutos * 60 * 1000).format("HH:mm");
  }

  verificaBusInhabilitado() {
    if(this.busInhabilitado) {
      this.estadoBus = 'EN_TALLER';
      this.estadoConductor = 'EN_TALLER';
    }
  }

  cambioEstadoBus() {
    if(this.estadoBus == 'EN_TALLER' && this.estadoConductor == 'EN_TALLER')
      this.busInhabilitado = true;
    else
      this.busInhabilitado = false;
  }

  cambioEstadoConductor() {
    if(this.estadoBus == 'EN_TALLER' && this.estadoConductor == 'EN_TALLER')
      this.busInhabilitado = true;
    else
      this.busInhabilitado = false;
  }

  getDetalleViaje() {
    this.apiService.getDetalleViaje(this.viaje.uuid).subscribe((resp) => this.getDetalleViajeSuccess(resp), (error) => this.getDetalleViajeError(error));
  }

  getDetalleViajeSuccess(getDetalleViajeResponseDTO: GetDetalleViajeResponseDTO) {
    console.log('exito detalle viaje', getDetalleViajeResponseDTO);
    this.detalleViaje = getDetalleViajeResponseDTO.data;
  }

  getDetalleViajeError(error: HttpErrorResponse) {
    console.log('error detalle viaje', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_DETALLE_VIAJE_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }


  postFinalizarViaje() {
    if(!this.busInhabilitado && (this.estadoBus == '' || this.estadoConductor == '')) {
      //alert('Debe seleccionar los estados del Bus y del Conductor para finalizar viaje');
      this.toastr.warning('Debe seleccionar los estados del Bus y del Conductor para finalizar viaje', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }

    if(this.busInhabilitado && this.estadoConductor == '') {
      this.toastr.warning('Debe seleccionar el estado del Conductor para finalizar viaje', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }

    let postFinalizarViajeResquestDTO = new PostFinalizarViajeResquestDTO();

    const estadoDefinitivoConductor = this.estadoConductor == 'FINALIZAR_E_IMPRIMIR' ? 'DISPONIBLE' : this.estadoConductor;

    postFinalizarViajeResquestDTO.initCampos(this.estadoBus, this.porcentajeCombustible, estadoDefinitivoConductor);

    this.enviando = true;
    this.apiService.postFinalizarViaje(this.viaje.uuid, postFinalizarViajeResquestDTO)
      .subscribe(res => this.postFinalizarViajeSuccess(res), error => this.postFinalizarViajeError(error));
  }


  postFinalizarViajeSuccess(generalResponseDTO: GeneralResponseDTO) {
    console.log('post finalizar viaje success', generalResponseDTO);
    //alert(generalResponseDTO.msg);
    //this.alertService.presentAlertaInfo(generalResponseDTO.msg);
    this.eventService.publish('VIAJE_FINALIZADO_SUCCESS');

    if(this.estadoConductor == 'FINALIZAR_E_IMPRIMIR'){
      this.finalizarJornadaConductor();
    } else {
      this.enviando = false;
    }
  }

  postFinalizarViajeError(error: HttpErrorResponse) {
    console.log('post finalizar viaje error', error);
    this.enviando = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_POST_FINALIZAR_VIAJE_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }


  finalizarJornadaConductor() {
    const now = moment.utc().seconds(0).milliseconds(0).toISOString().replace(/\.\d{3}Z$/, 'Z');

    const motivo = 'desconocido';

    this.apiService.putFinalizarJornadaGestionConductores(
      this.viaje.conductor.uuid,
      'FUERA_JORNADA',
      this.viaje.conductor.jornadaEnCurso.uuid,
      'FINALIZADA',
      now,
      motivo,
      ''
    ).subscribe({
      next: (res) => {
        console.log('Jornada de conductor finalizada exitosamente');
        this.imprimirFinalizarJornada();
      },
      error: (err) => {
        this.enviando = false;
        const msg = err.error && err.error.msg ? err.error.msg : AppMessage.ERROR_PUT_FINALIZAR_JORNADA_CONDUCTORES_WS;
        this.toastr.error(msg + (err['requestId'] ? ' Code: ' + err['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
      }
    });
  }

  imprimirFinalizarJornada(){

    this.apiService.getFinJornadaPDF(this.viaje.conductor.jornadaEnCurso.uuid).subscribe(
      (resp) => this.getFinJornadaPDFSuccess(resp),
      (error) => this.getFinJornadaPDFError(error)
    );
  }

  getFinJornadaPDFSuccess(pdfDTO: PdfDTO) {
    pdfDTO.generatePdfFromBase64();
    this.toastr.success('Documento generado correctamente', '', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
    this.enviando = false;
    this.close();
  }

  getFinJornadaPDFError(error: HttpErrorResponse) {
    this.enviando = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

}
